<table mat-table [dataSource]="dataSource">
	<ng-content></ng-content>
</table>
